import React from 'react'
import {
    //     Person1,
    //     IconStars,
    //     IconStore,
    //     IconNextweeek,
    //     IconUpdate,
    IconRefresh,
} from '../../Icons'
import Grid from '@material-ui/core/Grid/Grid'
import Paper from '@material-ui/core/Paper/Paper'
import withStyles from '@material-ui/core/styles/withStyles'
// import { Typography } from '@material-ui/core'
// import ButtonLink from '../../ButtonLink'
import AreaChart from './AreaChart'
import BarChart from './BarChart'
import FirstRow from './FirstRow'
import MyIconButton from '../../components/ButtonIcon'
import { row1Data } from './mockData1'

const styles = theme => ({
    container: {
        overflow: 'auto',
    },
    chartGrid: {
        paddingLeft: 20,
        paddingRight: 20,
    },
    chartWrapper: {
        marginTop: 40,
    },
    chartInfo: {
        padding: 12,
    },
    chartBox: {
        height: 280,
    },
})

class Dashboard extends React.Component {
    state = {
        data1: row1Data,
        chart1: [
            { name: '1 Nov', uv: 4000, pv: 2400, amt: 2400 },
            { name: '2 Nov', uv: 3000, pv: 1398, amt: 2210 },
            { name: '3 Nov', uv: 2000, pv: 9800, amt: 2290 },
            { name: '4 Nov', uv: 2780, pv: 3908, amt: 2000 },
            { name: '5 Nov', uv: 1890, pv: 4800, amt: 2181 },
            { name: '6 Nov', uv: 8562, pv: 3800, amt: 2500 },
            { name: '7 Nov', uv: 3000, pv: 5465, amt: 9000 },
        ],
        chart2: [
            { name: 'Jan', uv: 4000, pv: 2400, amt: 2400 },
            { name: 'Feb', uv: 3000, pv: 1398, amt: 2210 },
            { name: 'Mar', uv: 2000, pv: 9800, amt: 2290 },
            { name: 'Apr', uv: 2780, pv: 3908, amt: 2000 },
            { name: 'May', uv: 1890, pv: 4800, amt: 2181 },
            { name: 'Jun', uv: 2390, pv: 3800, amt: 2500 },
            { name: 'Jul', uv: 3490, pv: 4300, amt: 2100 },
        ],
    }

    refreshChart = type => {
        if (type === 1) {
            //refresh chart 1
            const { chart1 } = this.state

            this.setState({
                chart1: [
                    { name: 'Jan', uv: 0, pv: 0, amt: 2400 },
                    { name: 'Feb', uv: 0, pv: 0, amt: 2210 },
                    { name: 'Mar', uv: 0, pv: 0, amt: 2290 },
                    { name: 'Apr', uv: 0, pv: 0, amt: 2000 },
                    { name: 'May', uv: 0, pv: 0, amt: 2181 },
                    { name: 'Jun', uv: 0, pv: 0, amt: 2500 },
                    { name: 'Jul', uv: 0, pv: 0, amt: 9000 },
                ],
            })
            setTimeout(() => {
                this.setState({ chart1: chart1 })
            }, 50)
        } else {
            //refresh chart 2
            const { chart2 } = this.state
            this.setState({
                chart2: [
                    { name: '1 Nov', uv: 0, pv: 0, amt: 2400 },
                    { name: '2 Nov', uv: 0, pv: 0, amt: 2210 },
                    { name: '3 Nov', uv: 0, pv: 0, amt: 2290 },
                    { name: '4 Nov', uv: 0, pv: 0, amt: 2000 },
                    { name: '5 Nov', uv: 0, pv: 0, amt: 2181 },
                    { name: '6 Nov', uv: 0, pv: 0, amt: 2500 },
                    { name: '7 Nov', uv: 0, pv: 0, amt: 9000 },
                ],
            })
            setTimeout(() => {
                this.setState({ chart2: chart2 })
            })
        }
    }

    render() {

        const { classes } = this.props
        const { data1 } = this.state

        return (
            <Grid
                className={classes.container}
                xs={12}
                sm={12}
                md={12}
                lg={10}
                item
            >
                <FirstRow data={data1} />

                <Grid
                    className={classes.chartWrapper}
                    direction="row"
                    container
                >
                    <Grid className={classes.chartGrid} item xs={12} md={6}>
                        <Paper className={classes.chartInfo}>
                            <div className={classes.chartBox}>
                                <AreaChart data={this.state.chart1} />
                            </div>
                            <ChartInfo onpress={() => this.refreshChart(1)} />
                        </Paper>
                    </Grid>

                    <Grid className={classes.chartGrid} item xs={12} md={6}>
                        <Paper className={classes.chartInfo}>
                            <div className={classes.chartBox}>
                                <BarChart data={this.state.chart2} />
                            </div>
                            <ChartInfo onpress={() => this.refreshChart(2)} />
                        </Paper>
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}
export default withStyles(styles)(Dashboard)

const jss1 = {
    //     paddingTop: 6,
    paddingLeft: 20,
    paddingRight: 20,
    borderTopWidth: 1,
    borderTopColor: '#ccc',
    borderTopStyle: 'solid',
}

const ChartInfo = ({ info, onpress }) => (
    <Grid container justify="flex-end" direction="row" style={jss1}>
        {/* <Grid item>{info.i1}</Grid> */}
        {/* <Grid item>{info.i2}</Grid> */}
        <MyIconButton onTap={onpress} icon={<IconRefresh />} label="Refresh" />
    </Grid>
)
